import {Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {SensorHistoryRequest} from '../sensor-history-request';
import {Sensor} from 'shared';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-sensor-history',
  templateUrl: './sensor-history.component.html',
  styleUrls: ['./sensor-history.component.scss']
})
export class SensorHistoryComponent implements OnInit {

  @Input()
  sensor: Sensor;

  @Input()
  request: SensorHistoryRequest;

  @ContentChild(TemplateRef)
  templateRef: TemplateRef<any>;

  readonly store: ArrayStore;

  constructor() {
    this.store = new ArrayStore({
      data: [],
      key: 'id',
    });
  }

  ngOnInit(): void {
  }

}
